import { customAlphabet, nanoid } from 'nanoid';

// The order of characters is optimized for better gzip and brotli compression. removed -_ for URL
const urlAlphabet = 'useandom26T198340PX75pxJACKVERYMINDBUSHWOLFGQZbfghjklqvwyzrict';
const generator = customAlphabet(urlAlphabet, 5);

// mixed types (string and number) does not work well with JS objects,
// so always prefixing with _ so that id is always string and not number
export const generatePrefix = (prefix = '') => `${prefix}_`;

/**
 * Generate a unique id with a prefix. Even if there is no prefix, the id will be prefixed with an underscore.
 * This is needed since we want to avoid ids starting with a number, which causes ordering issues in operations
 * such as Object.keys(...).
 *
 * @param prefix - The prefix to add to the id
 * @returns The unique id with the prefix
 */
export function getIdWithPrefix(prefix?: string) {
  return generatePrefix(prefix).concat(generator());
}

export function getLongId() {
  return nanoid();
}

const autoGeneratedIdPattern = new RegExp(`^_[${urlAlphabet}]{5}$`);

/**
 * Detects ids produced by `getIdWithPrefix()` with no prefix (`_` + 5 alphabet chars).
 * Used to tell placeholder keys apart from user-entered ones.
 */
export function isAutoGeneratedId(id: string) {
  return autoGeneratedIdPattern.test(id);
}
